import { httpClient } from "./Service";

export const createCashMemo = async (cashMemoData: App.RefillEntry) => {
    try {
        const result = await httpClient("cashmemo", "POST", cashMemoData);
        return result;
    } catch (error) {
        console.error("Error creating cash memo:", error);
        throw error;
    }
};

export const getAllCashMemos = async () => {
    try {
        const result = await httpClient("cashmemo", "GET");
        return result;
    } catch (error) {
        console.error("Error fetching all cash memos:", error);
        throw error;
    }
};

export const getCashMemoById = async (id: string) => {
    try {
        const result = await httpClient(`cashmemo/${id}`, "GET");
        return result;
    } catch (error) {
        console.error(`Error fetching cash memo with ID ${id}:`, error);
        throw error;
    }
};

export const updateCashMemo = async (id: string, cashMemoData: App.RefillEntry) => {
    try {
        const result = await httpClient(`cashmemo/${id}`, "PUT", cashMemoData);
        return result;
    } catch (error) {
        console.error(`Error updating cash memo with ID ${id}:`, error);
        throw error;
    }
};

export const deleteCashMemo = async (id: string) => {
    try {
        const result = await httpClient(`cashmemo/${id}`, "DELETE");
        return result;
    } catch (error) {
        console.error(`Error deleting cash memo with ID ${id}:`, error);
        throw error;
    }
};